import css1 from '../img/portImages/R1.JPG';
import css2 from '../img/portImages/R2.JPG';
import R3 from '../img/portImages/R3.JPG'
import R4 from '../img/portImages/R4.JPG'
import R5 from '../img/portImages/R5.JPG'
import R6 from '../img/portImages/R6.JPG'
import R7 from '../img/portImages/R7.JPG'
import R8 from '../img/portImages/R8.JPG'
import R9 from '../img/portImages/R9.JPG'
import R10 from '../img/portImages/R10.JPG'
import R13 from '../img/portImages/R13.JPG'
import R14 from '../img/portImages/R14.png'
import R15 from '../img/portImages/R15.png'
import R16 from '../img/portImages/R16.png'
import img3 from '../img/portImages/a1.JPG';
import img4 from '../img/portImages/a2.JPG';
import img5 from '../img/portImages/a3.JPG';


const portfolios = [
    {
        
        id: 1,
        category: 'React-Node',
        image: R5,
        link1: 'https://github.com/sarthak37/Market-Place',
        link2: 'https://sarthak-market-place.onrender.com/',
        title: 'Market-Place',
        text: 'Market-Place is online shopping portal using react ,context and bootstrap in frontend rest api development using node js - mongo db along with braintree payment gateway and admin panel'
    },
        {
            id: 2,
            category: 'React-Node',
            image: R6,
            link1: 'https://github.com/sarthak37/Get-Together',
            link2: 'https://sarthak-get-together.onrender.com',
            title: 'GET-TOGETHER',
            text: 'GET-TOGETHER is online social media website with all functionalities like comment, post , follow along with audio and video call  using react ,redux and material ui in frontend rest api development using node js - mongo db along with websockets,peer js ,webrtc for chat , audio-video call support'
        },

        {
            id: 3,
            category: 'React-Node',
            image: R13,
            link1: 'https://github.com/sarthak37/DOCTORA-APP',
            link2: 'https://sarthak-doctora-app.onrender.com/',
            title: 'DOCTORA-APP',
            text: 'It is a doctor appointment booking web application , it is build with react , redux , node js and mongodb . User can book appointment with doctors and also apply to become doctor. It has an admin panel as well'
        },
    
   


    {
        id: 4,
        category: 'Python-Backend',
        image: R10,
        link1: 'https://github.com/sarthak37/FastApi-Mongodb',
        link2: 'https://fastapi-mongodb-p9f8.onrender.com/docs',
        title: 'Swagger page of rest Apis  shopping portal mongodb and fastapi ',
        text: 'A Swagger page which has end points of backend of ecommerce application in fastapi and mongodb, The application handles various scenarios such as checking if products exist, if there is enough quantity of products for an order, updating product quantities, and calculating the total cost of orders.'
    },
    {
        id: 5,
        category: 'AI/ML',
        image: R9,
        link1: 'https://github.com/sarthak37/Image-Tranformation-Web-App',
        link2: 'https://sarthak-image-fliter-transformation.onrender.com/',
        title: 'Image-Tranformation-Web-App',
        text: 'An Image Filtering and Transformation web app in Flask using Python and OpenCV. User has the option to choose the image, then choose number of tasks, then he has to select the tasks which he want to apply on image in the sequence.When user clicks the stylize button he can see the modified image , he also can download the image if he wants'
    },

    {
        id: 6,
        category: 'AI/ML',
        image: R14,
        link1: 'https://github.com/sarthak37/Bert-Fine-Tuning-Symptom-disease-prediction-web-app',
        link2: 'https://huggingface.co/spaces/Sarthak279/Symptom-based-disease-prediction',
        title: 'Disease-Prediction -based on Symptoms Application',
        text: 'A fine tune BERT model deployed on gradio. It can predict the 12 type of diseases on basis of symptoms Deployed on gradio'
    },

    
    
    {
        id: 7,
        category: 'React',
        image: R8,
        link1: 'https://www.google.com',
        link2: 'https://sarthak-portfolica.netlify.app/',
        title: 'Responsive Portfolio Website',
        text: 'Created using different technologies such as Material UI, Styled-Components and more...'
    },
    {

        id: 8,
        category: 'AI/ML',
        image: css1,
        link1: 'https://github.com/sarthak37/Animal-Breed-detection-React-and-Tensorflow',
        link2: 'https://sarthak-animal-breed-detection-model.netlify.app/',
        title: 'Animal Breed Detection ',
        text: 'Build with React js , Redux and Tensorflow js '

       
    },

     {
        id: 9,
        category: 'AI/ML',
        image: R15,
        link1: 'https://github.com/sarthak37/T5-Fine-Tuning-Health-Chatbot',
        link2: 'https://huggingface.co/spaces/Sarthak279/chatbot',
        title: 'Health Customer chatbot',
        text: 'A health customer chatbot deployed on gradio. Fine Tuned on custom dataset and on top with T5 LLM .It can answer query based on 13 intents. Deployed on gradio'
    },

    {
        id: 10,
        category: 'Python-Backend',
        image: R16,
        link1: 'https://github.com/sarthak37/Loan-Application',
        link2: 'https://sarthak-loan-emi-application.onrender.com/swagger/',
        title: 'Loan-Emi  application with swagger page in  Django',
        text: 'A django application with swagger ui backend and mysql database which first approves loan on basis of credit score recieved from transactions in csv file . User can be identified with Aadhar number. After loan is approved , loan id is generated along with emi. Emi can increase or decrease as well based on previous transaction. Deployed on render, tap on link to visit '
    },


    {
        id: 11,
        category: 'AI/ML',
        image: R7,
        link1: 'https://github.com/sarthak37/handwriiten-digit-detection-react-redux-and-tensorflow',
        link2: 'https://sarthak-handwritten-digit-prediction-model.netlify.app/',
        title: 'Handwritten Digit Detection ',
        text: 'A website build with react , material ui and tensorflow js to predict digit drawn by user'
    },

    


   
   

    


]

export default portfolios;